import React, {useCallback, useEffect, useState} from 'react';
import useStyles from './styles';
import {useDispatch, useSelector} from "react-redux";
import SuperGroupCards from "./components/SuperGroupCards";
import SearchHeader from "./components/SearchHeader";
import AutoSizerCatalog from "./components/AutoSizerCatalog";
import {addAssayToOrderList, getCatalog, setSelectedTags, setTags} from "@cabinet-packages/redux";
import {useAssaysFilter} from "@cabinet-packages/hooks";
import {ClientRegionDialogVdoma, CustomDialog, Loading} from "../../components";
import {isIncludedInOrderingList} from "@cabinet-packages/helpers";
import {getCatalogVdoma} from "@cabinet-packages/redux/actions/actionsCreators";

const ProductCatalogVdoma = ({}) => {
    const cl = useStyles();
    const dispatch = useDispatch();
    const {complexTransition, catalog, complexResearch, actions} = useSelector(state => state.assaysCatalog);
    const {amountOfItems, orderingList} = useSelector(state => state.orderAssays);
    const [catalogForView, setCatalogForView] = useState(null);
    const [selectedTag, setSelectedTag] = useState(null);
    const [loading, setLoading] = useState(false);
    const [prevStateOfCatalog, setPrevStateOfCatalog] = useState();
    const idReg = localStorage.getItem('idReg');
    const {themeMaterialUI} = useSelector(state => state.theme);
    const windowUrl =  window.location.pathname
    const url = window.location.pathname.split('/').pop()

    const addAssayCovid = useCallback(async () => {
        if(catalog && windowUrl === `/shop-assay-info/${url}` && complexResearch){
            const findAssay =   catalog.filter(el => +el.id === +url && !el.superGroupName)[0]
            if(findAssay === undefined) return
            if (!isIncludedInOrderingList(findAssay, orderingList)) {
                await  dispatch(addAssayToOrderList(
                    findAssay.id,
                    findAssay.discount ? findAssay.price - findAssay.price * findAssay.discount / 100 : findAssay.price,
                    () => {
                    },
                    findAssay.type,
                ))
            }
            setCatalogForView([...catalog, ...complexResearch].filter(item => !item.superGroupName));
            setSelectedTag('Усі');
        }
    })

    useEffect(() => {
        addAssayCovid()
    }, [catalog, windowUrl]);

    const addComplexCovid = useCallback(async () => {
        if(catalog && complexResearch && windowUrl === `/shop-complex-info/${url}`){
            const findAssay = complexResearch.filter(el => +el.id === +url && !el.superGroupName)[0]
            if(findAssay === undefined) return
            if (!isIncludedInOrderingList(findAssay, orderingList)) {
                await  dispatch(addAssayToOrderList(
                    findAssay.id,
                    findAssay.discount ? findAssay.price - findAssay.price * findAssay.discount / 100 : findAssay.price,
                    () => {
                    },
                    findAssay.type,
                ))
            }
            setCatalogForView([...catalog, ...complexResearch].filter(item => !item.superGroupName));
            setSelectedTag('Усі');
        }
    })

    useEffect(() => {
        addComplexCovid();
    }, [catalog, windowUrl, complexResearch]);

    const addActionCovid = useCallback(async () => {
        if(catalog && complexResearch && actions && windowUrl === `/shop-actions-details/${url}`){
            const findAssay = actions.filter(el => +el.id === +url && !el.superGroupName)[0]
            if(findAssay === undefined) return
            if (!isIncludedInOrderingList(findAssay, orderingList)) {
                await  dispatch(addAssayToOrderList(
                    findAssay.id,
                    findAssay.discount ? findAssay.price - findAssay.price * findAssay.discount / 100 : findAssay.price,
                    () => {
                    },
                    findAssay.type,
                ))
            }
            setCatalogForView([...catalog, ...complexResearch].filter(item => !item.superGroupName));
            setSelectedTag('Усі');
        }
    })

    useEffect(() => {
        addActionCovid()
    }, [catalog, windowUrl, complexResearch, actions]);

    const getCatalogCallback = useCallback(async () => {
        setLoading(true);
        await dispatch(getCatalogVdoma());
        await dispatch(setTags());
        setLoading(false);
    }, []);

    const {
        filteredState,
        filterValue,
        handleChangeFilterValue,
    } = useAssaysFilter(catalogForView);

    useEffect(() => {
        getCatalogCallback();
    }, [getCatalogCallback]);

    useEffect(() => {
        if (complexTransition && catalog && complexResearch) {
            setSelectedTag(null);
            dispatch(setSelectedTags([]));
            setCatalogForView([...complexResearch]);
        } else if (catalog && complexResearch && catalogForView && +catalogForView[0].idParent === 75) {
            setCatalogForView(null);
            setSelectedTag(null);
            dispatch(setSelectedTags([]));
        }
    }, [complexTransition]);

    useEffect(() => {
        if (!idReg) {
            localStorage.setItem('idReg', '2');
            dispatch(getCatalog());
        }
    }, []);

    useEffect(() => {
        if (!amountOfItems) {
            CustomDialog(ClientRegionDialogVdoma, {}, false, themeMaterialUI);
        }
    }, []);

    return (<div className={cl.root}>
        {!loading && <SearchHeader useCatalogForView={[catalogForView, setCatalogForView]}
                                   useSelectedTag={[selectedTag, setSelectedTag]}
                                   usePrevState={[prevStateOfCatalog, setPrevStateOfCatalog]}
                                   handleValue={[filterValue, handleChangeFilterValue]}
        />}
        {loading
            ? <Loading/>
            : catalogForView
                ? <AutoSizerCatalog useCatalogForView={[filteredState, setCatalogForView]}
                                    useSelectedTag={[selectedTag, setSelectedTag]}
                                    usePrevState={[prevStateOfCatalog, setPrevStateOfCatalog]}
                                    handleValue={[filterValue, handleChangeFilterValue]}
                                    activeScrollIndex={true}
                                    url={url}
                                    catalogForViewTrue={catalogForView}

                />
                : <SuperGroupCards setCatalogForView={setCatalogForView} setSelectedTag={setSelectedTag}
                                   usePrevState={[prevStateOfCatalog, setPrevStateOfCatalog]}/>
        }
    </div>);
};

export default ProductCatalogVdoma;
